export var Asset;
(function (Asset) {
    Asset["mixer"] = "mixer";
    Asset["vormmachineA"] = "vormmachineA";
    Asset["vormmachineB"] = "vormmachineB";
    Asset["oven"] = "oven";
    Asset["koeler"] = "koeler";
    Asset["inpakker"] = "inpakker";
})(Asset || (Asset = {}));
